import clsx from "clsx";
import styled, { css } from "styled-components";

export type VariantType = "normal" | "main" | "grey";
type StyledTableCellTextProps = { $variant?: VariantType; $highlight?: boolean };

const StyledTableCellText = styled.span.attrs<StyledTableCellTextProps>((props) => ({
    className: clsx(props.className, props.$highlight && "highlightText"),
}))<StyledTableCellTextProps>`
    ${({ $variant }) => {
        switch ($variant) {
            case "grey":
                return css`
                    color: var(--color-grey-800);
                `;
            case "main":
                return css`
                    color: var(--color-secondary);
                    font-weight: var(--weight-700);
                `;
            case "normal":
            default:
                return css`
                    color: var(--color-grey-900);
                `;
        }
    }}
`;

StyledTableCellText.defaultProps = {
    $variant: "normal",
    $highlight: false,
};

export default StyledTableCellText;
